<template>
  <div class="settingPage">
    <div class="infoHeader">
      <font-awesome-icon icon="cog" class="w3-right headerIcon" /><h2>{{ $t('settings.settings') }}</h2>
    </div>

    <table class="settingsTable"><tbody>
      <tr class="header"><td colspan="2">{{ $t('settings.userSettings') }}</td></tr>
      <tr><td class="xtendCol">{{ $t('settings.username') }}</td><td class="normalCol">{{userLogin}}</td></tr>
      <tr><td class="xtendCol">{{ $t('settings.userAccount') }}</td><td class="normalCol">{{userAccount}}</td></tr>
      <tr>
        <td class="xtendCol">
          {{ $t('settings.linkedTo') }}<br/>
          <router-link to="/info/linking-account/" class="infoLink"><font-awesome-icon class="info" icon="info-circle" /> {{ $t('settings.moreInfo') }}</router-link>
        </td>
        <td class="normalCol">
          <div class="settingValue" v-if="!accountLinked">{{ $t('settings.notLinked') }}
            <br/>
            <router-link :to="'/select-user'" class="imgbtn"><font-awesome-icon icon="link" /> {{ $t('settings.linkToAccount') }}</router-link>
          </div>
          <div class="settingValue" v-if="accountLinked">
            <router-link :to="userURL" class="imgbtn"><font-awesome-icon icon="user" /> {{ username }}</router-link>
            <br/>
            <router-link :to="'/select-user'" class="imgbtn"><font-awesome-icon icon="link" /> {{ $t('settings.linkToOtherAccount') }}</router-link>
          </div>
        </td></tr>
      <!--
      <div class="setting">
        <div class="settingName">{{ $t('settings.password') }}</div><div class="settingValue"> <router-link :to="'/change-password/' + username" class="specialLink">&gt; {{ $t('changePassword') }} &lt;</router-link></div>
      </div>  
      -->
    </tbody></table>
    
    <table class="settingsTable"><tbody>
      <tr class="header"><td colspan="2">{{ $t('settings.interface') }}</td></tr>
      <tr><td class="xtendCol">{{ $t('settings.language') }}</td><td class="normalCol"><select-locale></select-locale></td></tr>
      <tr><td class="xtendCol">{{ $t('settings.theme') }}</td><td class="normalCol"><select-theme></select-theme></td></tr>
    </tbody></table>
  </div>  
</template>

<script>

import selectLocale from '../../locale/selectLocale.vue';
import SelectTheme from './SelectTheme.vue';

export default {
  components: { selectLocale, SelectTheme },
  name: 'UserSettings',
  mounted() {
    console.log(JSON.stringify(this.$CAUser));
  },
  computed: {
    accountLinked: function() {
      return this.$CAUser.linked();
    },
    userLogin: function () {
      return this.$CAUser.getChessUser().login;
    },
    username: function () {
      return this.$CAUser.getChessUser().name;
    },
    userAccount: function () {
      return this.$CAUser.userAccount();
    },
    userURL: function() {
      console.log("user: " + JSON.stringify(this.$CAUser.getChessUser()));
      return "/persons/" + this.$CAUser.getPersonId();
    }
  },
  data: function () {
    return {}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  text-decoration: none;
}

.header {
  font-weight: bold;
}

.imgbtn {
  float: left;
  border: 1px solid #333333;
  margin-bottom: 4px;
}

.setting {
  display: flex;
  flex-direction: row;
}

.topicSection {
  width: 100%;
  padding: 6px;
}

.topicSection h3 {
  border-bottom: 1px solid blue;
}

.settingsTable {
  width: 100%;
  margin: 2vw 0vw 2vw 0vw;
  border: 1px solid #181818;
  border-radius: 2px;
}

tr:nth-child(odd) {
  background-color: #181818;
}

.normalCol {
  white-space: nowrap;
}
.xtendCol {
  width: 100%;
}

/* mobile */
@media screen and (max-width: 600px) {
  .settingPage {
    width: 98vw;
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .settingPage {
    min-width: 30vw;
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
  .settingPage {
    min-width: 30vw;
  }
}
</style>
